<p-card>
    <div class="grid">
        <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu flex align-items-right">
            <div class="flex align-items-right" style="margin-left: auto;margin-right: 0;">
            </div>
        </div>
    </div>
    <div class="grid" style="display: flex; justify-content: center; gap: 1rem;">
        <div class="col-12 md:col-3 lg:col-3 sm:col-6">
            <label class="bold-red-text" for="masters">Masters</label>
            <p-dropdown [options]="mastersList" [(ngModel)]="selectedMasters" optionLabel="label" optionValue="value"
                (onChange)="getConfiguration(selectedMasters, selectedActions);"
                styleClass="fixed-width-dropdown-filter" placeholder="Select" pTooltip="Select Master"
                [showClear]="true" [pTooltip]="getSelectedMasterTooltip()">
            </p-dropdown>
            <span *ngIf="masterErrorDisplay" style="color:red;">
                Master is required
            </span>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6"
            *ngIf="selectedMasters !== 'configuration' && selectedMasters !== 'organisation' && selectedMasters !== 'esign_transactions'">
            <label class="bold-red-text" for="actions">Actions</label>
            <p-dropdown [options]="actionsList" [(ngModel)]="selectedActions" optionLabel="label" optionValue="value"
                styleClass="fixed-width-dropdown-filter" placeholder="Select"
                (onChange)="getConfiguration(selectedMasters,selectedActions);" [disabled]="!selectedMasters"
                pTooltip="Select Action" [showClear]="true" [pTooltip]="getSelectedActionTooltip()"> </p-dropdown>
            <span *ngIf="actionErrorDisplay" style="color:red;">
                Action is required
            </span>
        </div>
    </div>
    <div class="grid" *ngIf="selectedMasters && selectedActions">
        <div class="col-12 md:col-2 lg:col-2 sm:col-6"
            *ngIf="selectedMasters == 'gen_subdepartment' && selectedActions =='Update'">
            <label class="bold-red-text" for="modifedRowId">Affected Department</label>
            <p-dropdown [options]="filteraffectedmastedata" [(ngModel)]="selectedAffectedMasterRow"
                (onChange)="getParams2($event,'Master Row')" [resetFilterOnHide]="true" styleClass="smart-dropdown"
                panelStyleClass="smart-dropdown-panel" [optionLabel]="masterOptionFieldName"
                [optionValue]="masterOptionFieldName" styleClass="fixed-width-dropdown-filter" appendTo="body"
                [pTooltip]="getAffectedDataTooltip()" inputId="affectedCategory" [filter]="true" placeholder="Select"
                [showClear]="true">
            </p-dropdown>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6"
            *ngIf="(selectedMasters == 'gen_subdepartment' || selectedMasters == 'esign_transactions' || selectedMasters == 'gen_usermapping')&& selectedActions =='Delete'">
            <label class="bold-red-text" for="modifedRowId">{{deletedMasterLabel}}</label>
            <p-dropdown [options]="filterdeletedmasterrow" [(ngModel)]="selectedDeletedMasterRow"
                (onChange)="getParams2($event,'Master Row')" [resetFilterOnHide]="true" styleClass="smart-dropdown"
                panelStyleClass="smart-dropdown-panel" [optionLabel]="masterOptionFieldName" appendTo="body"
                [optionValue]="masterOptionFieldName" styleClass="fixed-width-dropdown-filter"
                [pTooltip]="getDeletedMasterDataTooltip()" inputId="affectedCategory" [filter]="true"
                placeholder="Select" [showClear]="true">
            </p-dropdown>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6" *ngIf="selectedMasters == 'gen_subvertical'">
            <label class="bold-red-text" for="modifedRowId">Affected {{vertlabelname}}</label>
            <p-dropdown [options]="filteraffectedmastedata" [(ngModel)]="selectedAffectedMasterRow"
                (onChange)="getParams2($event,'Master Row')" [resetFilterOnHide]="true" styleClass="smart-dropdown"
                panelStyleClass="smart-dropdown-panel" [optionLabel]="masterOptionFieldName" appendTo="body"
                [optionValue]="masterOptionFieldName" styleClass="fixed-width-dropdown-filter"
                [pTooltip]="getAffectedDataTooltip()" inputId="affectedCategory" [filter]="true" placeholder="Select"
                [showClear]="true">
            </p-dropdown>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6" *ngIf="selectedActions == 'Update' || (selectedActions == 'Insert' && selectedMasters == 'gen_usermapping')">
            <label class="bold-red-text" for="modifedRowId">{{modifiedMasterLabel}}</label>
            <p-dropdown [options]="filteraffecteddata" [(ngModel)]="selectedModifedRow" styleClass="smart-dropdown"
                panelStyleClass="smart-dropdown-panel" (onChange)="getParams2($event,'Modifed Row')" appendTo="body"
                [resetFilterOnHide]="true" [optionLabel]="optionFieldName" [optionValue]="optionFieldName"
                styleClass="fixed-width-dropdown-filter" inputId="affectedCategory" [filter]="true" placeholder="Select"
                [showClear]="true" [pTooltip]="getModifiedRowTooltip()">
            </p-dropdown>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6" *ngIf="selectedActions == 'Update' || (selectedActions == 'Insert' && selectedMasters == 'gen_usermapping')">
            <label class="bold-red-text" for="modifedById">{{modifiedByLabel}}</label>
            <p-dropdown [options]="filtermodifedbydata" [(ngModel)]="selectedModifedBy" styleClass="smart-dropdown"
                panelStyleClass="smart-dropdown-panel" (onChange)="getParams2($event,'Modifed By')"
                [resetFilterOnHide]="true" optionLabel="updatedBy" optionValue="updatedBy" appendTo="body"
                [pTooltip]="getModifiedByTooltip()" styleClass="fixed-width-dropdown-filter" inputId="modifedById"
                [filter]="true" placeholder="Select User" [showClear]="true">
            </p-dropdown>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6" *ngIf="selectedActions == 'Delete'">
            <label class="bold-red-text" for="modifedById">Deleted By</label>
            <p-dropdown [options]="filterdeletedbydata" [(ngModel)]="selectedDeletedByRow" styleClass="smart-dropdown"
                panelStyleClass="smart-dropdown-panel" (onChange)="getParams2($event,'Deleted By')"
                [resetFilterOnHide]="true" optionLabel="deletedBy" optionValue="deletedBy" appendTo="body"
                styleClass="fixed-width-dropdown-filter" inputId="deletedById" [filter]="true" placeholder="Select user"
                [pTooltip]="getDeletedByTooltip()" [showClear]="true">
            </p-dropdown>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6"
            *ngIf="selectedMasters == 'userxproductxrole' && selectedActions == 'Update'">
            <label class="bold-red-text" for="modifedRowId">Affected Product</label>
            <p-dropdown [options]="filteraffectedmastedata" [(ngModel)]="selectedAffectedMasterRow"
                (onChange)="getParams2($event,'Master Row')" [resetFilterOnHide]="true" styleClass="smart-dropdown"
                panelStyleClass="smart-dropdown-panel" [optionLabel]="masterOptionFieldName" appendTo="body"
                [optionValue]="masterOptionFieldName" styleClass="fixed-width-dropdown-filter"
                inputId="affectedCategory" [filter]="true" placeholder="Select" [showClear]="true"
                [pTooltip]="getAffectedDataTooltip()">
            </p-dropdown>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6">
            <label class="bold-red-text" for="fromdate" class="bold-red-text">From Date</label>
            <p-calendar class="custom-calendar" (onSelect)="onDateChange()" [showIcon]="true"
                pTooltip="Select From Date" [(ngModel)]="filterinput.fromdate" placeholder="Choose Date"
                dateFormat="dd-M-yy" [readonlyInput]="true" styleClass="pcalendar-readonly" [showOtherMonths]="true"
                [selectOtherMonths]="true" (onSelect)="getdates(filterinput)" (onClearClick)="onclear(filterinput)"
                inputId="fromdate" [showButtonBar]="true" appendTo="body" [maxDate]="today">
            </p-calendar>
            <span *ngIf="fromdateerrorDisplay" style="color: red;">Please Choose from date</span>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6">
            <label class="bold-red-text" for="todate" class="bold-red-text">To Date</label>
            <p-calendar class="custom-calendar" (onSelect)="onDateChange()" pTooltip="Select To Date" [showIcon]="true"
                [(ngModel)]="filterinput.todate" placeholder="Choose Date" dateFormat="dd-M-yy"
                (onSelect)="getdates(filterinput)" [showOtherMonths]="true" [readonlyInput]="true"
                styleClass="pcalendar-readonly" [selectOtherMonths]="true" (onClearClick)="onclear(filterinput)"
                inputId="todate" [showButtonBar]="true" appendTo="body" [maxDate]="today">
            </p-calendar>
            <span *ngIf="errorDIsplay" style="color: red;">To date should be greater than from date</span>
            <span *ngIf="todateerrorDIsplay" style="color: red;">Please Choose To date</span>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6">
            <p-button styleClass="refreshbtn reset-btn" class="ml-2" severity="success" (click)="refreshFilters()"
                pTooltip="Reset">
                <i class="fa fa-refresh" aria-hidden="true"></i>
            </p-button>
        </div>
    </div>
    <!-- <div class="grid" *ngIf="selectedMasters && selectedActions">
        <div class="col-12 md:col-2 lg:col-2 sm:col-6">
            <label class="bold-red-text" for="fromdate" class="bold-red-text">From Date</label>
            <p-calendar class="custom-calendar" (onSelect)="onDateChange()" [showIcon]="true" pTooltip="Select From Date"
                [(ngModel)]="filterinput.fromdate" placeholder="Choose Date" dateFormat="dd-M-yy" [readonlyInput]="true"
                styleClass="pcalendar-readonly" [showOtherMonths]="true" [selectOtherMonths]="true"
                (onSelect)="getdates(filterinput)" (onClearClick)="onclear(filterinput)" inputId="fromdate"
                [showButtonBar]="true" appendTo="body">
            </p-calendar>
        </div>
        <div class="col-12 md:col-2 lg:col-2 sm:col-6">
            <label class="bold-red-text" for="todate" class="bold-red-text">To Date</label>
            <p-calendar class="custom-calendar"(onSelect)="onDateChange()" pTooltip="Select To Date" [showIcon]="true"
                [(ngModel)]="filterinput.todate" placeholder="Choose Date" dateFormat="dd-M-yy"
                (onSelect)="getdates(filterinput)" [showOtherMonths]="true" [readonlyInput]="true"
                styleClass="pcalendar-readonly" [selectOtherMonths]="true" (onClearClick)="onclear(filterinput)"
                inputId="todate" [showButtonBar]="true" appendTo="body">
            </p-calendar>
            <span *ngIf="errorDIsplay" style="color: red;">To date should be greater then from date</span>
        </div>
        <div class="filterbutton col-12 md:col-2 lg:col-2 sm:col-6">
            <p-button styleClass="refreshbtn reset-btn" class="ml-2" severity="success" (click)="refreshFilters()"
                pTooltip="Reset">
                <i class="fa fa-refresh" aria-hidden="true"></i>
            </p-button>
        </div>
    </div> -->
    <div style="margin-bottom: 1rem; font-weight: bold; font-size: 1rem;color: red;">
        Note: By default, only the records that have been updated or deleted today are displayed on this page. To view
        records from previous dates, please apply a filter.
    </div>
    <div class="mr-0 tablehiegt" *ngIf="selectedMasters && selectedActions">
        <p-table #dt [value]="formlistarray" [scrollable]="true" [globalFilterFields]="globalFilterFields"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" scrollDirection="horizontal"
            [rowHover]="true" [rows]="rowsize" [rowsPerPageOptions]="paginatorArray" [showCurrentPageReport]="true"
            [paginator]="formlistarray.length>0" [sortOrder]="-1" responsiveLayout="scroll" [first]="currentPageIndex"
            [customSort]="true" (onPage)="handlePageChange($event)" [resizableColumns]="true" columnResizeMode="expand"
            scrollHeight="{{commonScrollHeight}}"
            [sortField]="selectedActions === 'Update' ? 'updatedOn' : selectedActions === 'Delete'  ? 'deletedOn' : null">
            <ng-template pTemplate="caption">
                <div class="table-header">
                    <div class="grid">
                        <div class="col-12 md:col-10 sm:col-12 lg:col-10">
                            <span class="p-input-icon-lft">
                                <i icon="pi pi-search"></i>
                                <input class="form-control" pInputText type="text" id="tablesearch"
                                    (input)="dt.filterGlobal($any($event.target).value, 'contains'); searchTerm = $any($event.target).value;"
                                    placeholder="Search in Audit Log" class="tablesearch"
                                    pTooltip="Enter Search Criteria" tooltipPosition="top" />
                            </span>
                        </div>
                        <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
                            <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom"
                                (click)="exceldownloadModal=true">
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <ng-container *ngFor="let col of _selectedColumns">
                        <th pResizableColumn [pSortableColumn]="col.field" (click)="onHeaderClick(col.field, $event)"
                            *ngIf="col.isChecked">
                            {{col.header}}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                            <p-columnFilter (click)="$event.stopPropagation()" type="text" [field]="col.field"
                                display="menu"></p-columnFilter>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data>
                <tr>
                    <ng-container *ngFor="let col of _selectedColumns">
                        <!-- <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
                            <span tooltipPosition="left" pTooltip="{{data[col.field]}}">
                                {{data[col.field]}}
                            </span>
                        </td> -->
                        <td style="vertical-align: top;" *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
                            <span pTooltip=" {{data[col.field]}}" class="wrap-text" [innerHTML]="highlight(data[col.field],searchTerm)"></span> 
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="12" class="datanotfound">
                        No data available
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</p-card>

<p-dialog header="Excel Download" [(visible)]="exceldownloadModal" [modal]="true" [baseZIndex]="10000"
    [draggable]="true" [resizable]="false" position="center">
    <div class="dialog-content-min-excel" style=" text-align: center !important;">
        <div class="card">
            <p>{{excel_paragraph}}</p>
        </div>
    </div>

    <div class="custom-dialog-footer">
        <p-button class="m-1 w-full" label="Close" styleClass="customeclose"
            (click)="exceldownloadModal=false"></p-button>
        <p-button class="m-1 w-full" label="Download" styleClass="customesave" (click)="excelDownload()"></p-button>
    </div>
</p-dialog>